import styled from "styled-components";

export const TrendingGroupsLoadingSkeletonContainer = styled.div`
  display: flex;
  gap: 40px;

  margin: 0 0 40px 20px;

  @media (min-width: 600px) {
    margin: 0 0 40px 55px;
  }

  > div {
    display: flex;
    align-items: center;

    .index {
      font: 600 10.0625rem/100% "Inter";
      width: fit-content;

      // 10 and more than 10
      &[data-index^="1"]:not([data-index="1"]) {
        letter-spacing: -21px;
        left: -4px;
      }

      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      box-shadow: 0px 0px 48px 0px #00000040;

      position: relative;
      z-index: initial;
      left: 10px;

      @media (max-width: 1600px) {
        font-size: 8.0625rem;
      }

      @media (max-width: 1366px) {
        font-size: 6rem;
        left: 7px;
      }

      @media (max-width: 850px) {
        font-size: 6rem;
      }

      @media (max-width: 600px) {
        font-size: 3.75rem;
      }
    }
  }

  .skeleton {
    z-index: 1;

    > div {
      @media (max-width: 1366px) {
        max-height: 131.64px;
        aspect-ratio: 16 / 9;
        width: auto;
      }

      @media (max-width: 500px) {
        max-height: 122.39px;
        height: 102.31px;
      }

      @media (max-width: 420px) {
        height: 66.31px;
      }
    }
  }
`;
